module.exports = __webpack_public_path__ + "static/SaolDisplay-Medium-d0d5deadeb23655103fa51a36ee08804.woff";